const signUpAndAccount = [
  {
    id: "sign01",
    que: "How do I create an account on EHS Prints?",
    ans: 'Click on "Create New Account" after that and fill up the form to create your account.You can create your account on EHS Prints by entering and verifying your mobile number and email.',
  },
  {
    id: "sign02",
    que: "Do I need to provide an email and mobile number to create an account?",
    ans: "Providing an email and mobile number is mandatory to create an account on EHS Prints, as it will allow you to easily reset your password if you need to",
  },
  {
    id: "sign03",
    que: "If I forget my password,so what to do?",
    ans: "So you can click “forgot password?”and fill the forget password form and set your new password.",
  },
  {
    id: "sign04",
    que: "How do I change my personal details or email address?",
    ans: "You can easily change all your information on your account.Go to the login page then click “Personal Information”. Here you can change all your contact information.",
  },
  {
    id: "sign05",
    que: "How secure is the EHS Prints platform?",
    ans: "The information you input is encrypted (end-to-end) and it will not be accessible for any third parties.",
  },
];
const orderAndPayment = [
  {
    id: "order01",
    que: "How to place an order?",
    ans: "You can order directly from our website. Simply add the desired items to the cart and then proceed through the  checkout process.",
  },
  {
    id: "order02",
    que: "What happens if a clearance item is out of stock?",
    ans: "If a Clearance item is Out of Stock, we will automatically process a refund.",
  },
  {
    id: "order03",
    que: "How can I pay for my order on EHS Prints?",
    ans: "You can choose any payment method.We support following payment options : |1. Cash On Delivery |2. Credit Card |3. Debit Card |4. Net banking",
  },
  {
    id: "order04",
    que: "What should I do if my payment fails?    ",
    ans: "Please retry making the payment after ensuring that the information entered is accurate, including all account details, billing addresses and passwords. If your payment is debited from your account after a payment failure, it will be credited back within 3-4 days, after we receive a confirmation from the bank.",
  },
  {
    id: "order05",
    que: "I am being charged GST amount on my order. What is GST?",
    ans: "GST is a single tax on the supply of goods and services that is levied on every value addition (through production and services) and is added to a product's sale price. GST has to be borne/paid by the ultimate consumer of the product or service. GST subsumes all other taxes like Excise duty, VAT, Entry tax etc",
  },
];
const shippingAndDelivery = [
  {
    id: "shipping01",
    que: "I have received a partial item/partial order or an Untenanted/Void packet?",
    ans: "Kindly reach out to us for pilferage within 72 hours of delivery failing which the claim will not be entertained.  |Whilst we investigate, request you to please make note of the below pointers: |1. Please do not use the item for which claim is being raised.  |2. You may be required to information’s like, short description of the case (A few questions will be asked to help us understand the scenario)    |3. The snapshots of the packet and other boxes (If any) (Try to cover the sides which look   tampered/damaged as per the Users)    |4. The refund for prepaid/Cash on delivery orders will e done after the investigation    |5. You may not be liable for a refund, if he/she falls in any of the scenarios stated below:   | 6. Failure to provide adequate information about the case.    |7. Failure to provide snapshots of the packet and box(if any)    |8. If a pilferage delivery was received, pilferage claims must be made the same day.   | 9. You must not dispose of the packaging for 3 - 4 days post - delivery. We might need to pick-up your    packaging for investigation at our end.   |10. You have used the item for which claim was raised.    ",
  },
  {
    id: "shipping02",
    que: "How are orders placed on EHS Prints delivered to me?",
    ans: "All orders  placed are dispatched through Shiprocket courier service or through other courier partners such as Blue Dart, Delhivery Etc.",
  },
  {
    id: "shipping03",
    que: "Does EHS Prints deliver products outside India?",
    ans: "No. At this point, EHS Prints delivers products only within India.",
  },
  {
    id: "shipping04",
    que: "How can I get my order delivered faster?",
    ans: "Sorry, currently we do not have any service available to expedite the order delivery. In future, if we are offering such service and your area pin code is serviceable, you will receive a communication from our end.",
  },
  {
    id: "shipping05",
    que: "What are our Shipping Charges?",
    ans: "Our general shipping charge of Rs. 220/- and if your total order amount is above Rs. 2000/, we provide free shipping. If the order is cancelled, lost, or un-delivered to your preferred location, we will refund the complete   order amount including the convenience fee if paid online.",
  },
];
const returnAndExchange = [
  {
    id: "return01",
    que: "What is EHS Prints Return and Exchange Policy?",
    ans: "EHS Prints returns gives you an option to return items purchased on EHS Prints for any reason within the 7 day    period. Please email hello@ehsprints.com within 07 days of the order date. We only ask that you don't use the product and preserve its original condition, tags, and packaging. You are welcome to try on a product but please take adequate measure to preserve its condition.    During Pickup, our delivery agent may do a quality check on the return. For a successful pick up, we will initiate a doorstep refund for the return amount into the refund mode selected at the time of initiating the return request.",
  },
  {
    id: "return02",
    que: "What if any item is missing in my order?",
    ans: "We encourage customers to inspect the contents of their package(s) upon delivery. If any items are missing, please contact us within 72 hours. Any missing item inquiries will not be entertained after this time period.",
  },
  {
    id: "return03",
    que: "What if I received a damaged package?",
    ans: "If you received a damaged package, you can do one of the following: |1.Refuse Delivery on the basis that the package is delivered as damaged. |a) Send an email to hello@ehsprints.com along with the Order ID & damage details. |b) We will file a claim with the shipping carrier for the damaged package and either refund the  order or send out a replacement package. | 2. Accept Delivery & note it down as proof with the shipping carrier, at the time of acceptance. |a) Keep the package aside & take pictures of the damaged package and any damaged goods. |b) Send an email to hello@ehsprints.com along with the Order ID and the pictures showing  the damage. |c) Once we've received the proof of damage, we will follow up with the shipping carrier to file a claim for the damage and refund you for the damaged items. |d) It is imperative that none of the damaged items are used until the full investigation is complete. If any damaged items are used, we will be unable to issue a refund.",
  },
  {
    id: "return04",
    que: "Why have I not received my Refund despite Instant Refunds policy?",
    ans: "For refunds taken into a Bank Account (via IMPS), your refund will reflect in your account within 1 to 3 business days once it has been initiated at the doorstep. For refunds to source accounts (that is Credit Card, Debit Card and Net banking), your refund may take 3-4 days to reflect in your account depending upon your bank partner.",
  },
  {
    id: "return05",
    que: "I don't want to return, can i exchange for another similar product?",
    ans: "We are only set up to arrange returns and not exchanges.",
  },
];

export {
  signUpAndAccount,
  orderAndPayment,
  shippingAndDelivery,
  returnAndExchange,
};
